import Cookie from 'js-cookie';

let hideScrollMenu;

window.podskazka_tools = param => {
    $('.podskazka_tools').hide();
    $('.close_tool').hide();

    if (param === 'on') {
        hideScrollMenu = false;

        // Оставить включенным
        $('#toolsButOn').html(trans('common.fixing_leave_on'));

        // Отключить
        $('#toolsButOff').html(trans('common.fixing_turn_off'));
    } else {
        hideScrollMenu = true;
        $('#topfixed').removeClass('fixed transbg').addClass('default');

        // Включить
        $('#toolsButOn').html(trans('common.fixing_turn_on'));

        // Оставить отключенным
        $('#toolsButOff').html(trans('common.fixing_leave_off'));
    }

    var date = new Date();
    var minutes = 31536000;
    date.setTime(date.getTime() + minutes * 60 * 1000);

    Cookie.set('podskazka_tools', param, {expires: date, path: '/', secure: false});
};

var $menu = $('#topfixed');

$(window).scroll(function () {
    hideScrollMenu = Cookie.get('podskazka_tools') === 'off';

    if (
        $(this).scrollTop() > 300 &&
        $menu.hasClass('default') &&
        (typeof hideScrollMenu === 'undefined' || !hideScrollMenu)
    ) {
        $menu.removeClass('default').addClass('fixed transbg');
    } else if ($(this).scrollTop() <= 300 && $menu.hasClass('fixed')) {
        $menu.removeClass('fixed transbg').addClass('default');
    }
});

$menu.hover(
    function () {
        if ($(this).hasClass('fixed')) {
            $(this).removeClass('transbg');
        }
    },
    function () {
        if ($(this).hasClass('fixed')) {
            $(this).addClass('transbg');
        }
    }
);
